<template>
  <b-container fluid class="mt-4 container-md">
    <b-row>
      <b-col>
        <b-button v-b-modal.setup-campaign @click="newCamp" variant="outline-primary">Setup campaign</b-button>
      </b-col>
      <b-col align="center">
        <b-button
            variant="outline-primary"
            :disabled="this.voluumCamp === null || Object.keys(this.voluumCamp).length === 0"
            @click="mode = 'edit'"
            v-b-modal.setup-campaign>
          View Selected
        </b-button>
      </b-col>
      <b-col align="right">
        <b-button
            variant="danger"
            :disabled="this.voluumCamp === null || Object.keys(this.voluumCamp).length === 0"
            v-b-modal.delete-campaign>
          Delete Selected
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-table
          ref="campaigns"
          :items="items"
          :fields="fields"
          select-mode="single"
          selectable
          hover
          stacked="sm"
          show-empty
          fixed
          bordered
          small
          @row-selected="onRowSelected"
        >
        </b-table>
        <b-modal ref="newcampmodal" size="lg" id="setup-campaign" title="Setup New Voluum Campaign" @hidden="onNewCampClosed" no-stacking hide-footer centered>
          <b-form id="new-camp-form">
            <b-input-group class="mb-3" prepend="Alias">
              <b-form-input v-model="voluumCamp.alias"></b-form-input>
            </b-input-group>
            <b-input-group class="mb-3" prepend="Voluum camp ID (id)">
              <b-form-input :disabled="this.mode === 'edit'" v-model="voluumCamp.id"></b-form-input>
            </b-input-group>
            <b-input-group class="mb-3" prepend="External network camp ID (ext_id)">
              <b-form-input v-model="voluumCamp.ext_id"></b-form-input>
            </b-input-group>
            <b-form-checkbox
                class="mb-3"
                v-model="voluumCamp.is_paused"
                value=1
                unchecked-value=0>
              marks if the campaign is paused
            </b-form-checkbox>
            <b-input-group class="mb-3" prepend="API">
                <b-form-radio-group
                    id="api-radio"
                    v-model="voluumCamp.api"
                    :options="apiOptions"
                    buttons
                    button-variant="outline-primary"
                ></b-form-radio-group>
            </b-input-group>
            <b-input-group class="mb-3" prepend="Bid Manager">
              <b-form-radio-group
                  id="api-radio"
                  v-model="voluumCamp.bid_manager"
                  :options="bid_managerOptions"
                  buttons
                  button-variant="outline-primary"
                  @input="resetbid_managerKeys"
              ></b-form-radio-group>
            </b-input-group>
            <b-input-group class="mb-3" prepend="Voluum custom var (idzone_var_number)#">
              <b-form-input v-model="voluumCamp.idzone_var_number"></b-form-input>
            </b-input-group>
            <b-input-group class="mb-3" prepend="Min imps to enable blacklisting (min_imps_bl)">
              <b-form-input v-model="voluumCamp.min_imps_bl"></b-form-input>
            </b-input-group>
            <b-form-checkbox
                v-if="voluumCamp.min_imps_bl && voluumCamp.min_imps_bl !== ''"
                class="mb-3"
                v-model="voluumCamp.is_mark_only_bl"
                value=1
                unchecked-value=0>
              only mark blacklists in Voluum (dry run)
            </b-form-checkbox>
            <b-input-group class="mb-3"
                           v-if="voluumCamp.bid_manager"
                           prepend="Min imps to enable bid management (min_imps_bid)">
              <b-form-input v-model="voluumCamp.min_imps_bid"></b-form-input>
            </b-input-group>
            <b-form-checkbox
                v-if="voluumCamp.min_imps_bid && voluumCamp.min_imps_bid !== ''"
                class="mb-3"
                v-model="voluumCamp.is_mark_only_bid"
                value=1
                unchecked-value=0>
              only mark bids in Voluum (dry run)
            </b-form-checkbox>
            <b-input-group class="mb-3"
                           v-if="voluumCamp.bid_manager && voluumCamp.bid_manager === 'exploitation'"
                           prepend="Min Bid (min_bid)">
              <b-form-input v-model="voluumCamp.min_bid"></b-form-input>
            </b-input-group>
            <b-input-group class="mb-3"
                           v-if="voluumCamp.bid_manager && voluumCamp.bid_manager === 'exploitation'"
                           prepend="Suggested Bid (suggested_bid)">
              <b-form-input v-model="voluumCamp.suggested_bid"></b-form-input>
            </b-input-group>
            <b-input-group class="mb-3" v-if="voluumCamp.bid_manager && voluumCamp.bid_manager !== ''" prepend="Max bid during bid management (max_bid)">
              <b-form-input v-model="voluumCamp.max_bid"></b-form-input>
            </b-input-group>
            <b-input-group class="mb-3" prepend="No registration spending limit before blacklisting (spending_limit)">
              <b-form-input v-model="voluumCamp.spending_limit"></b-form-input>
            </b-input-group>
            <b-input-group class="mb-3" prepend="Too high ECPA (Click) threshold (rank1_ecpa_limit)">
              <b-form-input v-model="voluumCamp.rank1_ecpa_limit"></b-form-input>
            </b-input-group>
            <b-input-group class="mb-3" prepend="Too high ECPA (Registration) threshold (rank2_ecpa_limit)">
              <b-form-input v-model="voluumCamp.rank2_ecpa_limit"></b-form-input>
            </b-input-group>
            <b-input-group class="mb-3" prepend="Too high CVR (Click) threshold (rank1_cvr_limit)">
              <b-form-input v-model="voluumCamp.rank1_cvr_limit"></b-form-input>
            </b-input-group>
            <b-input-group class="mb-3" v-if="voluumCamp.bid_manager && voluumCamp.bid_manager === 'exploitation'" prepend="Alert when cost reached (alert_cost)">
              <b-form-input v-model="voluumCamp.alert_cost"></b-form-input>
            </b-input-group>
            <b-input-group class="mb-3" prepend="Camp creation date (from Voluum UI) (created_at)">
              <b-form-datepicker v-model="voluumCamp.created_at"></b-form-datepicker>
            </b-input-group>
          </b-form>
          <div v-if="errors.length" class="mt-2 alert-danger">
            <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="error in errors">{{ error }}</li>
            </ul>
          </div>
          <b-button class="mt-3" variant="outline-primary" block @click="onSave">Save</b-button>
        </b-modal>
        <b-modal
            scrollable
            id="delete-campaign"
            centered
            @ok="onDelete"
            class="d-block text-center"
            title="Delete confirmation">
            <p>
              Confirm you want to delete
            <b>{{ this.voluumCamp }}</b>
          </p>
        </b-modal>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Voluum",
  data() {
    return {
      mode: "new",
      voluumCamp: {api: "voluum", bid_manager: null},
      fields: ["alias", "voluum_id"],
      apiOptions: [
        { text: 'Voluum', value: 'voluum' },
        { text: 'Traffic Junky', value: 'trafficjunky' }
      ],
      bid_managerOptions: [
        { text: 'No Bid Manager', value: null },
        { text: 'Exploration', value: 'exploration' },
        { text: 'Exploitation', value: 'exploitation' }
      ],
      items: [],
      errors: []
    };
  },
  methods: {
    newCamp() {
      this.mode = 'new';
    },
    resetbid_managerKeys() {
      // clean up voluum camp keys from previous bid manager setting
      if (!this.voluumCamp.bid_manager) {
        delete this.voluumCamp.min_imps_bid;
        delete this.voluumCamp.is_mark_only_bid;
        delete this.voluumCamp.min_bid;
        delete this.voluumCamp.suggested_bid;
        delete this.voluumCamp.max_bid;
        delete this.voluumCamp.alert_cost;
      }
      if (this.voluumCamp.bid_manager && this.voluumCamp.bid_manager !== "exploration") {
        delete this.voluumCamp.min_bid;
        delete this.voluumCamp.suggested_bid;
        delete this.voluumCamp.alert_cost;
      }
    },
    onNewCampClosed() {
      this.voluumCamp = {api: "voluum", bid_manager: null};
      this.errors = [];
      this.$refs.campaigns.clearSelected();
    },
    async onListRefresh() {
      let user = firebase.auth().currentUser;
      let token = await user.getIdToken().then((t) => t);

      fetch(
          process.env.VUE_APP_BASE_URL +
          "voluum",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + token,
            },
          }
      ).then((response) => {
        if (!response.ok) {
          throw Error(response.body);
        }
        return response.json();
      }).then((json_payload) => {
        this.items = json_payload;
      }).catch((error) => {
        console.error("Error:", error);
      });
    },
    async onDelete() {
      let user = firebase.auth().currentUser;
      let token = await user.getIdToken().then((t) => t);

      await fetch(
          process.env.VUE_APP_BASE_URL +
          "voluum" +
          "?vid=" + this.voluumCamp.id,
          {
            method: "DELETE",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + token,
            },
          }
      ).then((response) => {
        if (!response.ok) {
          throw Error(response.body);
        }
        return response.text();
      }).catch((error) => {
        console.error("Error:", error);
      });
      this.onNewCampClosed();
      await this.onListRefresh();
    },
    async onRowSelected(items) {
      let user = firebase.auth().currentUser;
      let token = await user.getIdToken().then((t) => t);
      if (items && items[0]) {
        this.voluumCamp = await fetch(
            process.env.VUE_APP_BASE_URL +
            "voluum" +
            "?vid=" + items[0].voluum_id,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "JWT " + token,
              },
            }
        ).then((response) => {
          if (!response.ok) {
            throw Error(response.body);
          }
          return response.json();
        }).catch((error) => {
          console.error("Error:", error);
        });
        this.voluumCamp = this.voluumCamp[0];
      }
    },
    isNumeric(str) {
      if (typeof str === "string") return !isNaN(str) && !isNaN(parseFloat(str));
      else return true;
    },
    isValid() {
      this.errors = [];
      const mandatoryCols = new Set(["id", "alias", "ext_id", "idzone_var_number", "spending_limit", "created_at"]);
      const actualCols = new Set(Object.keys(this.voluumCamp).filter(key => this.voluumCamp[key] !== null));
      for (let col of mandatoryCols) {
        if (!actualCols.has(col)) {
          this.errors.push("Missing value: " + col);
        }
      }
      const lenCols = new Set(["id", "alias", "ext_id"]);
      const maxLen = 100;
      for (let col of lenCols) {
        if (actualCols.has(col) && this.voluumCamp[col].length > maxLen) {
          this.errors.push(col + " value too long (max " + maxLen + ")!");
        }
      }
      if (actualCols.has("min_imps_bid") && !actualCols.has("max_bid")) {
        this.errors.push("Missing value: max_bid");
      }
      const intCols = new Set(["idzone_var_number", "min_imps_bl", "min_imps_bid"]);
      for (let col of intCols) {
        if (actualCols.has(col)) {
          if (!this.isNumeric(this.voluumCamp[col]) || !Number.isInteger(Number.parseFloat(this.voluumCamp[col])) || Number.parseFloat(this.voluumCamp[col]) <= 0) {
            this.errors.push(col + " value must be a positive INT");
          }
        }
      }
      const floatCols = new Set(["min_bid", "suggested_bid", "max_bid", "spending_limit", "rank1_ecpa_limit", "rank2_ecpa_limit", "rank1_cvr_limit", "alert_cost"]);
      for (let col of floatCols) {
        if (actualCols.has(col)) {
          if (!this.isNumeric(this.voluumCamp[col]) || Number.parseFloat(this.voluumCamp[col]) < 0) {
            this.errors.push(col + " value must be a positive FLOAT");
          }
        }
      }
      if (this.voluumCamp.bid_manager) {
        if (!this.voluumCamp.min_imps_bid) {
          this.errors.push("min_imps_bid must be set to have a working bid manager");
        }
        if (actualCols.has("min_bid") && this.voluumCamp.min_bid > 3) {
          this.errors.push("min_bid is too high - must be set between 0 and 3");
        }
        if (actualCols.has("max_bid") && this.voluumCamp.max_bid > 10) {
          this.errors.push("max_bid is too high - must be set between 0 and 10");
        }
        if (actualCols.has("min_bid") && actualCols.has("suggested_bid") && actualCols.has("max_bid")
            && !(this.voluumCamp.min_bid < this.voluumCamp.max_bid
                && this.voluumCamp.min_bid < this.voluumCamp.suggested_bid
                && this.voluumCamp.suggested_bid < this.voluumCamp.max_bid)) {
          this.errors.push("min, suggested and max bid values are not in increasing order");
        }
      }

      if (this.mode === "new" && this.items.some(obj => obj.voluum_id === this.voluumCamp.id)) {
        this.errors.push("A campaign with this Voluum ID is already linked");
      }

      if (this.errors.length > 0) {
        return false;
      }
      return true;
    },
    async onSave() {
      let user = firebase.auth().currentUser;
      let token = await user.getIdToken().then((t) => t);
      //TODO remove empty values from voluum camp
      if (this.isValid()) {
        await fetch(
            process.env.VUE_APP_BASE_URL +
            "voluum",
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "JWT " + token,
              },
              body: JSON.stringify(this.voluumCamp, (key, value) => {
                return ['', null].includes(value) || (typeof value === 'object' && (value.length === 0 || Object.keys(value).length === 0)) ? undefined : value;
              })
            }
        ).then((response) => {
          if (!response.ok) {
            throw Error(response.body);
          }
          return response.text();
        }).catch((error) => {
          console.error("Error:", error);
        });
        await this.onListRefresh();
        this.$refs.newcampmodal.hide();
      }
    },
  },
  created() {
    this.onListRefresh();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Voluum.vue